import { useState, useEffect } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { axiosClient } from '.';
// @ts-ignore - resolves to src/store.js via NODE_PATH, same as lib/client
import store from 'store';


const useAxios = function <T> (options: AxiosRequestConfig<any> | null) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | unknown | AxiosError>(null);

  useEffect(() => {
    // Skip when the caller has nothing to request yet (e.g. no organization
    // selected). Avoids firing requests like /organizations/undefined/...
    if (!options) {
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        // Attach the session token the same way lib/client does, so authenticated
        // shark endpoints (e.g. form-completions) don't 401. axiosClient targets
        // shark only, so the token is never sent anywhere else.
        const session = store.getState().session || {};
        const token = session.accessToken || session.tempAccessToken;
        const authedOptions: AxiosRequestConfig<any> = token
          ? { ...options, headers: { 'x-token': token, ...(options.headers || {}) } }
          : options;
        const response = await axiosClient(authedOptions);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [JSON.stringify(options)]);

  return { data, loading, error };
};

export default useAxios;
